var exports = {
  "kJ": "GiftEmbed.module__iconCircle___bjlWdV",
  "SP": "GiftEmbed.module__iconCircleActive___bjlWdV",
  "PP": "GiftEmbed.module__iconCircleInactive___bjlWdV",
  "_O": "GiftEmbed.module__iconCircleDisabled___bjlWdV",
  "Kk": "GiftEmbed.module__icon___bjlWdV",
  "m5": "GiftEmbed.module__iconError___bjlWdV",
  "DD": "GiftEmbed.module__title___bjlWdV",
  "jn": "GiftEmbed.module__titlePrimary___bjlWdV",
  "xP": "GiftEmbed.module__titleTertiary___bjlWdV",
  "S3": "GiftEmbed.module__titleDanger___bjlWdV",
  "xF": "GiftEmbed.module__subRow___bjlWdV",
  "Cz": "GiftEmbed.module__helpRow___bjlWdV",
  "mj": "GiftEmbed.module__skeletonCircle___bjlWdV",
  "Iz": "GiftEmbed.module__skeletonTitle___bjlWdV",
  "hI": "GiftEmbed.module__skeletonHelp___bjlWdV",
  "G3": "GiftEmbed.module__skeletonButton___bjlWdV",
};

module.exports = exports;
